import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { attachSearchBar, showSearchBar, hideSearchBar } from '../actions/masterbrand';

const initialState = {
  attached: false,
  visible: false
};

export default handleActions({
  [attachSearchBar]: state => ({ ...state, attached: true }),
  [showSearchBar]: state => ({ ...state, visible: true }),
  [hideSearchBar]: state => ({ ...state, visible: false })
}, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/search-bar.js